module.exports = __webpack_public_path__ + "img/statusQueryAct.2bc9ceac.png";